/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Reducedfftemperature3Inputs */



/**
* | output |
* | --- |
* | "Reduced frost-free temperature" |
*
* @param {Br_History_Key_Reducedfftemperature3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_reducedfftemperature3 = /** @type {((inputs?: Br_History_Key_Reducedfftemperature3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Reducedfftemperature3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Reduced frost-free temperature")
	return /** @type {LocalizedString} */ ("Température de réduit hors gel")
});
export { br_history_key_reducedfftemperature3 as "br_history_key_reducedFFTemperature" }